import I18n from 'I18n';

// formats a tiemstamp as "MMM D" (e.g. "Jan 20") if from current year
// or "MMM D (YYYY)" (e.g. "Jan 20 (2020)") if from different year

export function formatDateRelativeToCurrentYear(timestamp) {
  const date = I18n.moment.userTz(timestamp);
  const currentYear = I18n.moment.userTz().year();
  if (date.year() === currentYear) {
    return date.format('MMM D');
  }
  return date.format('MMM D (YYYY)');
}